import { Icon } from './icon.model';
export enum FeedbackType {
  Success,
  Warning,
  Failure,
}

export type FeedbackActionButton = {
  text?: string;
  handler?: () => void;
  classes?: string;
  icon?: Icon;
  tooltip?: string;
};

export class FeedbackModel {
  constructor(
    public type: FeedbackType = FeedbackType.Success,
    public message: string = '',
    public duration: number = 5000,
    public url: string = null,
    public urlText: string = null,
    public button: FeedbackActionButton = null
  ) {}
}
